!((document, Drupal, $) => {

  'use strict';

  /**
   * Handle search block
   */
  Drupal.behaviors.blockSearch = {

    attach: function(context) {

      // eslint-disable-next-line max-len
      const $blockSearchPage = $(once('blockSearchPage', '.block-search-page', context));
      $blockSearchPage.each(function () {
        // Change field data to avoid id/name conflicts
        $(this).find('.uk-form-label')
          .attr('for', 'search-page-edit-keywords');
        $(this).find('.uk-search-input')
          .attr('data-drupal-selector', 'search-page-edit-keywords')
          .attr('id', 'search-page-edit-keywords');
      });

    }

  };
// eslint-disable-next-line no-undef
})(document, Drupal, jQuery);
